import { createComponent } from '@lit-labs/react';
import React from 'react';
import { CustomValidity, Replacement } from '.';

export class PhoneInputDS extends HTMLElement {
  required?: boolean;
  maxLength?: string;
  class?: string;
  value: unknown;
  label?: string;
  replacement?: string | Replacement[];
  customValidityPattern?: string | CustomValidity[];
  placeholder?: string;
  constructor() {
    super();
  }
}

export const PhoneInput = createComponent(React, 'phone-input', PhoneInputDS, {
  onInputChange: 'input-changed',
  onFocus: 'element-focused',
  onLetterChanged: 'letter-changed',
  onBlur: 'element-blured',
});
